import { ordersStatisticsAggregateDate as orderUtilsOrdersStatisticsAggregateDate } from '@utils/orderUtils';
import { currencyConstants, loyaltyConstants } from '@utils/constants';
import currencySimpleUtility from '@utils/currencySimple';
import mutationTypes from '@helpers/storeFactories/helpers/mutationTypes';
import loyaltyPointsFormat from '@/utils/loyaltyPointsFormat';

const STORE_NAME = 'loyaltyTransactions';

export default {
    name: STORE_NAME,
    namespaced: true,
    state: {
        items: null,
        totalCount: 0,
        switchCurrencyType: loyaltyConstants.STATISTICS.TYPE.US_DOLLAR,
    },
    mutations: {
        [mutationTypes.SET_DATA](state, data) {
            const { items, totalCount } = data.loyaltyTransactions || { items: [], totalCount: 0 };

            state.items = items;
            state.totalCount = totalCount;
        },
        [mutationTypes.CLEAR_DATA](state) {
            state.items = null;
            state.totalCount = 0;
        },
        UPDATE_SWITCH_CURRENCY_TYPE(state, data) {
            state.switchCurrencyType = data;
        },
    },
    getters: {
        switchCurrencyType: (state) => state.switchCurrencyType,
        isSwitchCurrencyTypeDollar: (state) =>
            state.switchCurrencyType === loyaltyConstants.STATISTICS.TYPE.US_DOLLAR,
        pointsRedeemedRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: loyaltyPointsFormat(
                                item.pointsRedeemed,
                                loyaltyConstants.CURRENCY_TYPES.POINTS,
                                'points',
                                false
                            ),
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsRedeemed,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        pointsEarnedRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: loyaltyPointsFormat(
                                item.pointsEarned,
                                loyaltyConstants.CURRENCY_TYPES.POINTS,
                                'points',
                                false
                            ),
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsEarned,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        pointsRedeemedCashRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: currencySimpleUtility(
                                item.pointsRedeemedCash,
                                currencyConstants.DEFAULT
                            ),
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsRedeemedCash,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        pointsEarnedCashRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: currencySimpleUtility(
                                item.pointsEarnedCash,
                                currencyConstants.DEFAULT
                            ),
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsEarnedCash,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        pointsRedeemedTransactions:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: item.pointsRedeemedTransactions,
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsRedeemedTransactions,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        pointsEarnedTransactions:
            (state, getters, rootState) =>
            (returnType = Array) => {
                if (state.items) {
                    let returnTypeObject = [],
                        returnTypeArray = [];
                    state.items.forEach((item) => {
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: item.pointsEarnedTransactions,
                        });
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.pointsEarnedTransactions,
                        ]);
                    });

                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        cashBackRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                let count = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.items) {
                    state.items.forEach((item) => {
                        count += item.cashBackInBaseCurrency;
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.cashBackInBaseCurrency,
                        ]);
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: currencySimpleUtility(
                                item.cashBackInBaseCurrency,
                                currencyConstants.DEFAULT
                            ),
                        });
                    });
                }

                if (count > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        cashBackCashRevenue:
            (state, getters, rootState) =>
            (returnType = Array) => {
                let count = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.items) {
                    state.items.forEach((item) => {
                        count += item.cashBack;
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.cashBack,
                        ]);
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: currencySimpleUtility(
                                item.cashBack,
                                rootState.ordersStatistics.baseCurrency
                            ),
                        });
                    });
                }

                if (count > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
        cashBackTransactions:
            (state, getters, rootState) =>
            (returnType = Array) => {
                let count = 0,
                    returnTypeObject = [],
                    returnTypeArray = [];

                if (state.items) {
                    state.items.forEach((item) => {
                        count += item.cashBackTransactions;
                        returnTypeArray.push([
                            orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            item.cashBackTransactions,
                        ]);
                        returnTypeObject.push({
                            date: orderUtilsOrdersStatisticsAggregateDate(
                                item.date,
                                rootState.ordersStatistics.filter.from.aggregateLevel
                            ),
                            value: item.cashBackTransactions,
                        });
                    });
                }

                if (count > 0) {
                    switch (returnType) {
                        case Object:
                            return returnTypeObject;
                        default:
                            return returnTypeArray;
                    }
                }

                return null;
            },
    },
    actions: {
        updateSwitchCurrencyType({ commit }, switchCurrencyType) {
            return commit('UPDATE_SWITCH_CURRENCY_TYPE', switchCurrencyType);
        },
    },
};
